<div class="relative mx-auto min-h-[400px] max-w-3xl space-y-5">
  @if (isStripeOnboardingSuccess) {
    <div hlmAlert variant="info">
      <ng-icon name="lucideCircleCheck" />
      <p hlmAlertTitle>Zahlungen sind aktiv</p>
      <p hlmAlertDescription>
        Hier verwaltest du deine Zahlungsinformationen und Auszahlungskonten.
      </p>
    </div>
  } @else {
    <section hlmCard>
      <div hlmCardHeader>
        <h2 hlmCardTitle>Auszahlungen einrichten</h2>
        <p hlmCardDescription>
          Damit deine Kunden bezahlen können, verbinde dein Bankkonto sicher über
          <a
            href="https://stripe.com/de"
            target="_blank"
            rel="noopener noreferrer"
            class="underline underline-offset-4"
            >Stripe</a
          >
          – den Zahlungsdienst von Amazon, Shopify & Co. Dauert etwa 5 Minuten.
        </p>
        <div hlmCardAction>
          <span hlmBadge variant="secondary">
            <ng-icon name="lucideShieldCheck" />
            Sicher via Stripe
          </span>
        </div>
      </div>

      <div hlmCardContent class="space-y-4">
        <div class="text-muted-foreground flex flex-wrap gap-x-4 gap-y-1.5 text-xs">
          <span class="flex items-center gap-1">
            <ng-icon name="lucideEyeOff" /> Wir sehen keine Bankdaten
          </span>
          <span class="flex items-center gap-1">
            <ng-icon name="lucideBanknote" /> Direkt auf dein Konto
          </span>
          <span class="flex items-center gap-1">
            <ng-icon name="lucideLock" /> PCI-DSS zertifiziert
          </span>
        </div>

        <details class="group">
          <summary
            class="text-muted-foreground hover:text-foreground flex cursor-pointer items-center gap-1 text-xs transition-colors select-none">
            <ng-icon name="lucideChevronRight" class="transition-transform group-open:rotate-90" />
            Wie funktioniert das genau?
          </summary>
          <div hlmItem variant="muted" class="mt-2 flex-col items-start gap-2">
            <p hlmMuted class="text-xs">
              Schenkwerk leitet Zahlungen deiner Kunden über Stripe direkt auf dein eigenes Konto
              weiter. Das Geld fließt nie über uns – Stripe überweist es dir automatisch.
            </p>
            <p hlmMuted class="text-xs">
              Dafür benötigt Stripe einmalig ein paar Angaben zu deinem Unternehmen und deiner
              Bankverbindung. Das ist gesetzlich vorgeschrieben (EU-Zahlungsrichtlinie) und schützt
              dich vor Betrug.
            </p>
          </div>
        </details>
      </div>
    </section>
  }

  @if (stripeReviewPending && !isStripeOnboardingSuccess) {
    <div hlmAlert variant="info">
      <ng-icon name="lucideClock" />
      <p hlmAlertTitle>Stripe prüft deine Angaben</p>
      <p hlmAlertDescription>
        Deine Angaben sind vollständig bei Stripe eingegangen. Die Prüfung dauert meist nur wenige
        Minuten, selten bis zu zwei Werktage. Öffne diese Seite danach noch einmal, dann schalten
        wir Zahlungen für deinen Shop frei.
      </p>
    </div>
  }

  @if (error) {
    <div hlmAlert variant="destructive">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>{{ error }}</p>
      @if (error?.includes('Profil')) {
        <button hlmBtn variant="outline" size="sm" class="mt-2" (click)="goToOnboarding()">
          Profil vervollständigen
        </button>
      }
    </div>
  }

  @if (showLoadingSpinner) {
    <div
      id="stripe-mount-loader"
      class="absolute inset-0 flex flex-col items-center justify-center gap-3">
      <hlm-spinner class="text-[length:--spacing(8)]" />
      <p hlmMuted class="text-center text-sm">
        Wir laden deine Zahlungseinstellungen.<br />Bitte habe etwas Geduld…
      </p>
    </div>
  }

  <!-- Stripe mounts its embedded components into these nodes -->
  <div id="stripe-connect-mount"></div>
  <div id="stripe-account-management-mount"></div>
</div>
